<template>
    <div class="home">
        <div class="top">
            <h1>Welcome <span class="name">{{ user.name }}</span>!</h1>
        </div>

        <div v-if="dashboard">
            <div class="statBoxes flex flex-wrap">

                <div class="statBoxColumn">
                    <div class="statBox">
                        <svg svg-inline="" class="statBoxIcon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4"/></svg>
                        <h4 class="statBoxLabel">
                            Products
                        </h4>
                        <p>
                            Number products: {{ dashboard.number_products }} st
                        </p>
                        <div class="statBoxButtons">
                            <AppButton
                                label="See all"
                                url="/products"
                                small
                            />
                            <AppButton
                                label="Add product"
                                url="/products/create"
                                small
                            />
                        </div>
                    </div>
                </div>

                <div class="statBoxColumn">
                    <div class="statBox">
                        <svg svg-inline="" class="statBoxIcon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>
                        <h4 class="statBoxLabel">
                            Documents
                        </h4>
                        <p>
                            Number documents: {{ dashboard.number_documents }} st
                        </p>
                        <div class="statBoxButtons">
                            <AppButton
                                label="See all"
                                url="/documents"
                                small
                            />
                            <AppButton
                                label="Add document"
                                url="/documents/create"
                                small
                            />
                        </div>
                    </div>
                </div>

                <div class="statBoxColumn">
                    <div class="statBox">
                        <svg svg-inline="" class="statBoxIcon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                        <h4 class="statBoxLabel">
                            Media items
                        </h4>
                        <p>
                            Number media items: {{ dashboard.number_media }} st
                        </p>
                        <div class="statBoxButtons">
                            <AppButton
                                label="See all"
                                url="/media-library"
                                small
                            />
                            <AppButton
                                label="Add media item"
                                url="/media-library"
                                small
                            />
                        </div>
                    </div>
                </div>

                <div class="statBoxColumn">
                    <div class="statBox">
                        <svg svg-inline="" class="statBoxIcon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                        <h4 class="statBoxLabel">
                            Users
                        </h4>
                        <p>
                            Number users: {{ dashboard.number_users }} st
                        </p>
                        <div class="statBoxButtons">
                            <AppButton
                                label="See all"
                                url="/users"
                                small
                            />
                            <AppButton
                                label="Add user"
                                url="/users/create"
                                small
                            />
                        </div>
                    </div>
                </div>

            </div>

            <div class="my-10">
                <h3>Latest updated products</h3>
                <Table
                    :headers="productUpdatedHeaders"
                    :buttons="false"
                    :items="dashboard.latest_updated_products"
                >
                    <template slot-scope="{ item }">
                        <td
                            v-for="header in productUpdatedHeaders"
                            :key="header.property"
                        >
                            <component
                                :is="header.link && !item.deleted_at ? 'router-link' : 'span'"
                                :to="header.link ? `products/${item.id}` : null"
                                :class="header.link && !item.deleted_at ? 'link' : ''"
                            >
                                {{ item[header.property] }}
                            </component>
                        </td>
                    </template>
                </Table>
            </div>

            <div class="mb-10">
                <h3>Latest added products</h3>
                <Table
                    :headers="productCreatedHeaders"
                    :buttons="false"
                    :items="dashboard.latest_created_products"
                >
                    <template slot-scope="{ item }">
                        <td
                            v-for="header in productCreatedHeaders"
                            :key="header.property"
                        >
                            <component
                                :is="header.link && !item.deleted_at ? 'router-link' : 'span'"
                                :to="header.link ? `products/${item.id}` : null"
                                :class="header.link && !item.deleted_at ? 'link' : ''"
                            >
                                {{ item[header.property] }}
                            </component>
                        </td>
                    </template>
                </Table>
            </div>

        </div>
    </div>
</template>

<script>
import Table from '../components/table/Table.vue';
import Box from '../components/ui/Box.vue';
import AppButton from '../components/ui/AppButton.vue';
import { get } from '../utils/apiHelper';

export default {
    components: {
        Table,
        Box,
        AppButton,
    },
    data: () => ({
        dashboard: false,
        productCreatedHeaders: [
            {
                text: 'Title', property: 'title', align: 'left', link: true,
            },
            { text: 'Article number', property: 'article_number', align: 'left' },
            { text: 'Created', property: 'created_time_ago', align: 'left' },
        ],
        productUpdatedHeaders: [
            {
                text: 'Title', property: 'title', align: 'left', link: true,
            },
            { text: 'Article number', property: 'article_number', align: 'left' },
            { text: 'Updated', property: 'updated_time_ago', align: 'left' },
        ],
    }),
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        },
    },
    async created() {
        this.dashboard = await get('/api/dashboard');
    },
};
</script>

<style lang="postcss" scoped>
.top {
    margin-bottom: 30px;
}
.name {
    display: inline-block;
    text-transform: lowercase;
    &:first-letter {
        text-transform: uppercase;
    }
}
.statBoxes {
    margin: -10px;
}
.statBoxColumn {
    width: 25%;
    padding: 10px;
}
.statBox {
    text-align: center;
    box-shadow: var(--shadow);
    border-radius: var(--borderRadius);
    background-color: #fff;
    padding: 30px;
    height: 100%;
}
.statBoxIcon {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
}
.statBoxLabel {
    margin-bottom: 10px;
}
.statBoxButtons {
    margin: -5px 0;
}
.statBoxButtons .appButton {
    margin: 5px 5px;
}
</style>
